export default {
  selected: {},
  evaluation: {},
  secondEvaluation: {},
  priorityObjects: {},
  alternativeObjects: {},
  offer: {},
  assign: {},
  depositProviderDetails: [],
  buyingConfirmation: {},
  selectWidgetItems: [],
  detailView: {
    loading: true,
  },
};
